var global = require('./_global')
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/library/modules/_shared.js
// module id = ../../../../core-js/library/modules/_shared.js
// module chunks = 7